import EngineIndex, {
  loader as engineIndexLoader,
  action as engineIndexAction,
} from '.';
import EngineLayout from './layouts/EngineLayout';

import EngineCalendars from './pages/EngineCalendars';
import EngineClients from './pages/EngineClients';
import EngineDatabase from './pages/EngineDatabase';
import EngineInbox from './pages/EngineInbox';
import EngineLibrary from './pages/EngineLibrary';
import EnginePayroll from './pages/EnginePayroll';
import EngineProjects from './pages/EngineProjects';
import EngineServer from './pages/EngineServer';
import EngineSettings from './pages/EngineSettings';
import EngineStorage from './pages/EngineStorage';
import EngineSupport from './pages/EngineSupport';
import EngineTimesheets from './pages/EngineTimesheets';
import EngineVideo, { loader as videoLoader } from './pages/EngineVideo';
import EngineProjectDetails, {
  loader as projectDetailsLoader,
} from './pages/EngineProjectDetails';

export const engineRoutes = {
  path: 'engine',
  element: <EngineLayout />,
  children: [
    {
      index: true,
      element: <EngineIndex />,
      loader: engineIndexLoader,
      action: engineIndexAction,
    },
    {
      path: 'projects/:projectId',
      element: <EngineProjectDetails />,
      loader: projectDetailsLoader,
    },
    { path: 'calendars', element: <EngineCalendars /> },
    { path: 'clients', element: <EngineClients /> },
    { path: 'database', element: <EngineDatabase /> },
    { path: 'inbox', element: <EngineInbox /> },
    { path: 'library', element: <EngineLibrary /> },
    { path: 'payroll', element: <EnginePayroll /> },
    { path: 'projects', element: <EngineProjects /> },
    { path: 'server', element: <EngineServer /> },
    { path: 'settings', element: <EngineSettings /> },
    { path: 'storage', element: <EngineStorage /> },
    { path: 'support', element: <EngineSupport /> },
    { path: 'timesheets', element: <EngineTimesheets /> },
    { path: 'video', element: <EngineVideo />, loader: videoLoader },
  ],
};
